export function withCatch<T>(promise: Promise<T>): Promise<[any, undefined] | [undefined, T]> {
  return promise
    .then((data) => {
      return [undefined, data] as [undefined, T];
    })
    .catch((error) => {
      return [error, undefined] as [any, undefined];
    });
}
